import {
  GET_CURRENT_LEARNER_FAILURE,
  GET_CURRENT_LEARNER_REQEST,
  GET_CURRENT_LEARNER_SUCCESS,
  GET_LEARNER_FAILURE,
  GET_LEARNER_REQUEST,
  GET_LEARNER_SUCCESS,
  GET_MY_ENROLLED_COURSES_FAILURE,
  GET_MY_ENROLLED_COURSES_REQUEST,
  GET_MY_ENROLLED_COURSES_SUCCESS,
  RESET_ALL_ACTIONS,
  UPDATE_LEARNER_FAILURE,
  UPDATE_LEARNER_REQUEST,
  UPDATE_LEARNER_SUCCESS,
} from "./ActionType";

const initialState = {
  learner: null,
  isLoading: false,
  error: null,

  updateLearnerResponse: null,
  updateLearnerError: null,
  updateLearnerIsLoading: false,

  currentLearner: null,
  currentLearnerIsLoading: false,
  currentLearnerError: null,

  myEnrolledCourses: null,
  myEnrolledCoursesIsLoading: false,
  myEnrolledCoursesError: null,
};
export const learnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEARNER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_LEARNER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        learner: action.payload,
      };
    case GET_LEARNER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case UPDATE_LEARNER_REQUEST:
      return {
        ...state,
        updateLearnerIsLoading: true,
        updateLearnerError: null,
      };

    case UPDATE_LEARNER_SUCCESS:
      return {
        ...state,
        updateLearnerIsLoading: false,
        updateLearnerResponse: action.payload,
        updateLearnerError: null,
      };

    case UPDATE_LEARNER_FAILURE:
      return {
        ...state,
        updateLearnerIsLoading: false,
        updateLearnerError: action.payload,
      };
    case GET_CURRENT_LEARNER_REQEST:
      return {
        ...state,
        currentLearnerIsLoading: true,
        currentLearnerError: null,
      };
    case GET_CURRENT_LEARNER_SUCCESS:
      return {
        ...state,
        currentLearnerIsLoading: false,
        currentLearnerError: null,
        currentLearner: action.payload,
      };
    case GET_CURRENT_LEARNER_FAILURE:
      return {
        ...state,
        currentLearnerIsLoading: false,
        currentLearnerError: action.payload,
      };
    case GET_MY_ENROLLED_COURSES_REQUEST:
      return {
        ...state,
        myEnrolledCoursesIsLoading: true,
        myEnrolledCoursesError: null,
      };
    case GET_MY_ENROLLED_COURSES_SUCCESS:
      return {
        ...state,
        myEnrolledCoursesIsLoading: false,
        myEnrolledCoursesError: null,
        myEnrolledCourses: action.payload,
      };
    case GET_MY_ENROLLED_COURSES_FAILURE:
      return {
        ...state,
        myEnrolledCoursesIsLoading: false,
        myEnrolledCoursesError: action.payload,
      };
    case RESET_ALL_ACTIONS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
